<div>
    <router-outlet><app-spinner></app-spinner></router-outlet>
</div>
